import React, { PureComponent, createElement } from 'react';
import { defaultsDeep, set, assign } from 'lodash';
import { Modal, message as AntMessage } from 'antd';
import { ComponentsManager, builder, actions } from '@comall-backend-builder/core';
import { language } from '../../../language';

let SELECTED_ROW = [];

const getConfig = () => {
    return {
        component: 'Card',
        entity: 'DesignTopicSelector',
        content: {
            component: 'FlexLayout',
            direction: 'vertical',
            items: [
                {
                    component: 'FilterForm',
                    componentId: 'DesignTopicFilterForm',
                    direction: 'inline',
                    fields: [
                        {
                            property: 'name',
                        },
                    ],
                    submit: {
                        icon: 'search',
                        text: '',
                    },
                    style: {
                        marginBottom: 16,
                        float: 'right',
                    },
                },
                {
                    component: 'DataTable',
                    componentId: 'DesignTopicDataTable',
                    loadFirstPage: true,
                    rowSelection: {
                        type: 'radio',
                        onChange: () => {},
                        onSelect: function() {
                            SELECTED_ROW = arguments[2];
                        },
                    },
                    pagination: {
                        pageSize: 10,
                    },
                    columns: [
                        {
                            property: 'name',
                        },
                    ],
                },
            ],
        },
    };
};

function initDynamicComponent(contentConfig) {
    const componentName = 'Design-Topic-Panel';
    if (!ComponentsManager.has(componentName)) {
        let config = defaultsDeep(contentConfig, getConfig());
        set(config, 'content.items[1].componentId', 'DesignTopicDataTable');
        set(config, 'content.items[1].rowSelection', {
            type: 'radio',
            onChange: () => {},
            onSelect: function() {
                SELECTED_ROW = arguments[2];
            },
            onSelectAll: function() {
                SELECTED_ROW = arguments[2];
            },
        });
        ComponentsManager.register(componentName, config);
    }
}

/**
 * 可视化-配置链接-选择专题
 */

export class SelectTopic extends PureComponent<{
    contentConfig?: Record<string, any>;
    modalConfig?: Record<string, any>;
    onChange: (data: any) => void;
    onCancel: () => void;
    showModal: boolean;
}> {
    renderComponent = null;
    dispatch = null;

    constructor(props) {
        super(props);
        const { contentConfig } = props;
        initDynamicComponent(contentConfig);
        this.renderComponent = createElement(ComponentsManager.get('Design-Topic-Panel'));
        this.dispatch = builder.getStore().dispatch;
    }

    onOk = () => {
        if (!SELECTED_ROW.length) {
            AntMessage.error(language.getText('components.Tools.topicSelectRequired'));
            return;
        }

        const { onChange } = this.props;
        let linkParams = {};
        if (SELECTED_ROW.length) {
            const row = SELECTED_ROW[0];
            linkParams = { id: row['id'], name: row['name'] };
        }
        onChange(linkParams);

        SELECTED_ROW = [];
        this.dispatch(actions.tableRowSelectionChangeAction('DesignTopicDataTable', []));
    };

    onCancel = () => {
        const { onCancel } = this.props;
        onCancel();
    };

    render() {
        const { modalConfig = {}, showModal } = this.props;
        let props = {
            onCancel: this.onCancel,
            onOk: this.onOk,
        };
        assign(props, { width: 800, visible: showModal, title: '选择专题' }, modalConfig);
        return <Modal {...props}>{this.renderComponent}</Modal>;
    }
}
